import React, { useState } from 'react';

export default function PSEFile(props) {
  const [selectedOption, setSelectedOption] = useState('1');
  const [fileIndex, setFileIndex] = useState(0);

  const records = props.records;
  const fileIdValues = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  const generateDate = (date, includeHour) => {
    return `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}${includeHour ? `${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}` : ''}`;
  };

  const handleTextFile = () => {
    const time = new Date();

    // Encabezado de archivo
    let fileContent = '01'
      + '0000000000000000'
      + '0000000000000000'
      + '000'
      + generateDate(time, true)
      + fileIdValues[fileIndex]
      + '01'
      + '\n';

    // Encabezado de lote
    fileContent += '05'
      + '0000000000000'
      + '0001'
      + '               '
      + '\n';

    let total = 0;

    records.map((record, i) => {
      const price = selectedOption === '1' ? 0 : Number(record.price);
      
      // Detalle
      fileContent += '06'
        + String(record.idNumber).padStart(48, '0')
        + record.email.padEnd(32, ' ')
        + String(record.billedMonths).padStart(2, '0')
        + '   '
        + String(price.toFixed(2)).replace('.', '').padStart(14, '0')
        + '             '
        + '00000000000000'
        + generateDate(time, false)
        + '00000000'
        + String(record.accountNumber).padStart(17, '0')
        + String(record.accountType).split('/')[0].padStart(2, '0')
        + String(record.idNumber).padStart(16, '0')
        + record.name.padEnd(22, ' ')
        + '   '
        + (String(record.accountType).split('/')[0] === '3' ? '01' : '  ')
        + String(i + 1).padStart(7, '0')
        + '\n';

      total += Number(price);
    });

    // Control de lote
    fileContent += '08'
      + String(records.length).padStart(9, '0')
      + String(total.toFixed(2)).replace('.', '').padStart(18, '0')
      + '0001'
      + '\n';

    // Control de archivo
    fileContent += '09'
      + String(records.length).padStart(9, '0')
      + String(total.toFixed(2)).replace('.', '').padStart(18, '0');


    const blob = new Blob([fileContent], { type: 'text/plain' });

    const anchorElement = document.createElement('a');
    anchorElement.href = URL.createObjectURL(blob);
    anchorElement.download = 'Débitos-automáticos-PSE.txt';

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    URL.revokeObjectURL(anchorElement.href);

    const index = fileIndex <= 34 ? fileIndex + 1 : 35;
    setFileIndex(index);
  };

  const handleSelectedOption = (e) => {
    setSelectedOption(e.target.value);
  };

  return (
    <div className='PSEFile'>
      <div className='PSEFile-Options'>
        <label>
          <input
            type='radio'
            name='pseoption'
            value={'1'}
            checked={selectedOption === '1'}
            onChange={handleSelectedOption}
          />
          Prenotificación (valores en 0)
        </label>
        <label>
          <input
            type='radio'
            name='pseoption'
            value={'2'}
            checked={selectedOption === '2'}
            onChange={handleSelectedOption}
          />
          Incluir valores
        </label>
      </div>
      <button type='button' onClick={handleTextFile}>Descargar archivo de débitos</button>
    </div>
  )
}
